module.exports = __webpack_public_path__ + "static/media/PU3030F0.49aaac23.png";